// extracted by mini-css-extract-plugin
export default {"resetButton":"wIh4qrB","root":"wNbRB15","active":"eEjTl35"};